import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyWidgetProduct" })
export default class MyWidgetProduct extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public data: any = null;

    @Prop() readonly culture: string;

    get isOrderWidgetVisible() {
        return this.$store.getters["mybeghellidashboardStore/isOrderWidgetVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;
        this.data = (await Axios.post(this.routes.MyBeghelliDashboard_GetWidgetProductData, null)).data;
        this.isLoading = false;
    }

    public getValue(item: any): string {
        let title = item.find(x => x.culture === this.culture)?.value;
        if (!title) {
            title = item.find(x => x.culture === "en-US").value
        }
        return title;
    }
};